<template>
  <div class="swiperDepartment">
    <div class="swiperContent" ref="content">
      <swiper class="swiperCarrousel SwiperArticles" :class="{ 'padding-30': showBtn }" :options="swiperOption" v-if="showSwiper">
        <swiper-slide
           class="swiper-slide box-slide"
           :class="{ 'swiper-no-swiping': !canSwiper }"
           v-for="(departmentBanner, index) in departmentBannerVoList"
           :key="index">
          <div class="slide-img" ref="slideImg">
            <div class="slideImg-warp-mask" @click="goDetail($store.getters.getObject(departmentBanner.langMap).buttonUrl)"></div>
            <img :src="$store.getters.getObject(departmentBanner.langMap).bannerImage" :alt="$store.getters.getObject(departmentBanner.langMap).bannerName" />
          </div>
        </swiper-slide>
      </swiper>

      <div class="swiper-department-prev" ref="prevBtn" v-if="showBtn" slot="button-prev">
        <i class="icon-arrow-down"></i>
      </div>
      <div class="swiper-department-next" ref="nextBtn" v-if="showBtn" slot="button-next">
        <i class="icon-arrow-down"></i>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "SwiperDepartment",
  data() {
    return {
      totalRows: 0,
      showBtn: true,
      canSwiper: true,
      showSwiper: false,
      swiperOption: {
        loop: false,
        autoHeight: true,
        slidesPerView: 2.2,
        spaceBetween: 0,
        autoplay: {
          delay: 3000,
          disableOnInteraction: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  computed: {
    innerwidth() {
      return this.$store.state.innerWidth;
    },
    language() {
      return this.$store.state.language;
    },
    fontsize() {
      return this.$store.state.fontSize;
    },
  },
  watch: {
    innerwidth(news, old) {
      // this.showSwiper = false;
      this.setWidth();
    },
    departmentBannerVoList: function (news, old) {
      this.setWidth();
    },
    language: function (n, o) {
      this.setWidth();
    },
    fontsize: function (n, o) {
      // debugger;
      this.setWidth();
    },
  },
  props: {
    departmentBannerVoList: {
      type: Array,
    }
  },
  methods: {
    goJobDetail: function (id) {

    },
    formatDay: function (no) {
      let num = "";
      if (no >= 30) {
        num = Math.floor(no / 30) + this.$i18n.t("message.monthsAgo");
      } else if (no >= 7) {
        num = Math.floor(no / 7) + this.$i18n.t("message.weeksAgo");
      } else if (no == 0) {
        num = this.$i18n.t("message.today");
      } else {
        num = no + this.$i18n.t("message.daysAgo");
      }
      return num;
    },
    setWidth: function () {
      var that = this;
      this.$refs.content.style.width = "100%";
      if (this.$store.state.innerWidth > 600) {
        if( this.departmentBannerVoList.length <= 5 ) {
          this.showBtn = false
        } else {
          this.showBtn = true
        }
      } else {
        if( this.departmentBannerVoList.length > 2 ) {
          this.showBtn = true
        } else {
          this.showBtn = false
        }
      }

      if (this.$store.state.innerWidth >= 1345) {
        this.swiperOption = {
          loop: false,
          autoplay: {
            delay: 3000,
            disableOnInteraction: true,
          },
          slidesPerView: 5,
          spaceBetween: 15,
          navigation: {
            nextEl: ".swiper-department-next",
            prevEl: ".swiper-department-prev",
          },
        };
      } else if (this.$store.state.innerWidth >= 1080) {
        var space = (this.$store.state.innerWidth - 85 - 250 * 4) / 3;
        this.swiperOption = {
          loop: false,
          autoplay: {
            delay: 3000,
            disableOnInteraction: true,
          },
          slidesPerView: 4,
          spaceBetween: space,
          navigation: {
            nextEl: ".swiper-department-next",
            prevEl: ".swiper-department-prev",
          },
        };
      } else if (this.$store.state.innerWidth >= 815) {
        var space = (this.$store.state.innerWidth - 85 - 250 * 3) / 2;
        this.swiperOption = {
          autoplay: {
            delay: 3000,
            disableOnInteraction: true,
          },
          loop: false,
          slidesPerView: 2.8,
          spaceBetween: space,
          navigation: {
            nextEl: ".swiper-department-next",
            prevEl: ".swiper-department-prev",
          },
        };
      } else if (this.$store.state.innerWidth > 768) {
        this.swiperOption = {
          loop: false,
          autoplay: {
            delay: 3000,
            disableOnInteraction: true,
          },
          slidesPerView: 2.5,
          spaceBetween: 15,
          navigation: {
            nextEl: ".swiper-department-next",
            prevEl: ".swiper-department-prev",
          },
        };
      } else {
        this.swiperOption = {
          loop: false,
          autoplay: {
            delay: 3000,
            disableOnInteraction: true,
          },
          slidesPerView: 'auto',
          spaceBetween: 10,
          navigation: {
            nextEl: ".swiper-department-next",
            prevEl: ".swiper-department-prev",
          },
        };
      }
      var that = this;
      this.showSwiper = false;
      this.$nextTick(() => {
        this.showSwiper = true;
        setTimeout(function () {
          that.setHeightEvent();
        });
      });
    },
    setHeightEvent: function () {
      var height = 0;
      if (this.$refs.swiper) {
        for (var i = 0; i < this.$refs.swiper.length; i++) {
          if (this.$refs.swiper[i].offsetHeight > height) {
            height = this.$refs.swiper[i].offsetHeight;
          }
        }
        for (var i = 0; i < this.$refs.swiper.length; i++) {
          this.$refs.swiper[i].style.height = height + "px";
        }
      }
      if(this.$refs.slideImg) {
        for(var i = 0; i < this.$refs.slideImg.length; i++) {
          let rate = (this.$store.state.innerWidth - 95) * 0.48 / 263;
          let height = Math.round(98 * rate);
          let top = Math.round((200 - height) / 16);

          if(this.$store.state.innerWidth > 600) {
            if( this.departmentBannerVoList.length > 5 ) {
              this.$refs.prevBtn.style.top = "26%";
              this.$refs.nextBtn.style.top = "26%";
            }
          } else if(this.$store.state.innerWidth > 500) {
            if( this.departmentBannerVoList.length > 2 ) { 
              this.$refs.prevBtn.style.top = "23%";
              this.$refs.nextBtn.style.top = "23%";
            }
            if(this.departmentBannerVoList.length >= 2) {
              this.$refs.slideImg[i].style.height = height + "px";
            } else {
              this.$refs.slideImg[i].style.height = "98px"
            }
          } else if(this.$store.state.innerWidth > 450) {
            this.$refs.slideImg[i].style.height = height + "px";
            if( this.departmentBannerVoList.length > 2 ) {
              this.$refs.prevBtn.style.top = "19%";
              this.$refs.nextBtn.style.top = "19%";
            }
            if(this.departmentBannerVoList.length >= 2) {
              this.$refs.slideImg[i].style.height = height + "px";
            } else {
              this.$refs.slideImg[i].style.height = "98px"
            }
          } else if(this.$store.state.innerWidth > 400) {
            this.$refs.slideImg[i].style.height = height + "px";
            if( this.departmentBannerVoList.length > 2 ) {
              this.$refs.prevBtn.style.top = "9%";
              this.$refs.nextBtn.style.top = "9%";
            }
            if(this.departmentBannerVoList.length >= 2) {
              this.$refs.slideImg[i].style.height = height + "px";
            } else {
              this.$refs.slideImg[i].style.height = "98px"
            }
          } else {
            this.$refs.slideImg[i].style.height = height + "px";
            if( this.departmentBannerVoList.length > 2 ) {
              this.$refs.prevBtn.style.top = "2%";
              this.$refs.nextBtn.style.top = "2%";
            }
            if(this.departmentBannerVoList.length >= 2) {
              this.$refs.slideImg[i].style.height = height + "px";
            } else {
              this.$refs.slideImg[i].style.height = "98px"
            }
          }

        }
      }


    },
    goDetail: function (url) {
      let https = "https://";
      let http = "http://";
      if(url.indexOf(https) < 0 && url.indexOf(http) < 0) {
        url = "http://" + url
      }
      window.open(url, "_blank")
    },
  },
  mounted() {
    // this.mySwiper = new Swiper('.swiper-container')
    this.setWidth();
    var that = this;
    setTimeout(function () {
      that.setWidth();
    }, 500);
  },
};
</script>
